import styles from '../SizeAndWeightStyles.module.css';
import { useToggle } from '../../../../CustomHooks/useToggle';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { Box } from '@material-ui/core';

const CollapsingHeader = ({ id, title, children, defaultOpen = true, nightMode = false }) => {
  const [open, toggleOpen] = useToggle(defaultOpen);
  return (
    <>
      <Box id={id} display={"flex"} flexDirection={"row"} alignItems={"center"}>
        <h3 className={styles['leftMargin']} style={{ marginTop: '3px', marginBottom: '3px' }}>{title}</h3>
        {open ? <ExpandMore data-testid="expand-more" onClick={toggleOpen} /> : <ExpandLess data-testid="expand-less" onClick={toggleOpen} />}
      </Box>
      {open && <div className={nightMode ? styles['nightModeGreyBackground'] : styles['greyBackground']}>
        {children}
      </div>}
    </>
  );
}

export default CollapsingHeader;